import { MenuProps, TextColor } from '@brainpool/components';

export const useHeaderMenu = (): MenuProps => {
  return {
    direction: 'column',
    position: 'start',
    textColor: 'white' as TextColor,
    items: [
      { label: 'Projects', path: '/projects' },
      { label: 'New Project', path: '/new-project' },
      { label: 'Reporting', path: '/reporting', disabled: true },
      { label: 'Billing', path: '/billing' },
      { label: 'Settings', path: '/settings', disabled: true },
      { label: 'Help', path: '/help', disabled: true },
    ],
  };
};
